// 我的档案相关
const vipCourse = () => import('@/pages/svipProduct/index.vue');
const vipService = () => import('@/pages/svipProduct/service.vue');
const vipExperienceProduct = () => import('@/pages/svipProduct/experienceProduct.vue');
const vipExperience = () => import('@/pages/svipProduct/experience.vue');

export default [
  {
    path: '/svipCourse',
    component: vipCourse,
  },
  {
    path: '/svipService',
    component: vipService,
  },
  {
    path: '/svipExperienceProduct',
    component: vipExperienceProduct,
  },
  {
    path: '/svipExperience',
    component: vipExperience,
  },
];

